// eslint-disable-next-line import/no-cycle
import {
  fetchKpiEntry,
  fetchDailyKpiInfo,
  updateKpiEntry,
  fetchTeamData,
  updateSortByOrderOfKpiApi,
  fetchWeeklyTotals,
  fetchUserAchievements,
  updateUserCelebrationDate,
  getUserCelebrationDetails,
  updateSoundEnabledConfig,
  fetchUserNotifications,
  clearAllNotifications,
  setSeenNotification,
  clearAllNotificationsForWinWireMessage,
} from "apis/home";
import { put, takeEvery } from "redux-saga/effects";
import { enqueueSnackbar } from "notistack";
import { homeAction } from "../slice/home";

export function* getDailyPointsInfo() {
  try {
    const info = yield fetchDailyKpiInfo();

    if (info?.data?.success) {
      yield put(
        homeAction.getDailyPointsInfo({
          data: info.data.data.sort((a, b) => (a.KpiActivity?.name > b.KpiActivity?.name ? 1 : -1)),
        })
      );
    } else if (info?.response?.status !== 403) {
      enqueueSnackbar(
        JSON.stringify({
          icon: "error",
          title: "Error",
          text: info?.response?.data?.message || "Something went wrong",
        }),
        {
          variant: "custom",
        }
      );
      yield put(homeAction.getDailyPointsInfoFail());
    }
  } catch (error) {
    enqueueSnackbar(
      JSON.stringify({
        icon: "error",
        title: "Error",
        text: error?.response?.data?.message || error.message || "Something went wrong",
      }),
      {
        variant: "custom",
      }
    );
    yield put(homeAction.getDailyPointsInfoFail());
  }
}

export function* getUserAchievements() {
  try {
    const info = yield fetchUserAchievements();
    if (info?.data?.success) {
      yield put(
        homeAction.getUserAchievementsSuccess({
          pointGoals: info?.data?.pointGoals,
          activeStreak: info?.data?.activeStreak,
        })
      );
    } else {
      yield put(homeAction.getUserAchievementsFailure());
    }
  } catch (error) {
    enqueueSnackbar(
      JSON.stringify({
        icon: "error",
        title: "Error",
        text: error?.response?.data?.message || error.message || "Something went wrong",
      }),
      {
        variant: "custom",
      }
    );
    yield put(homeAction.getUserAchievementsFailure());
  }
}

export function* getKpiEntry(action) {
  try {
    const info = yield fetchKpiEntry(action.payload);

    if (info?.data?.success) {
      yield put(
        homeAction.getKpiEntry({
          lastUpdated: info?.data?.lastUpdated,
          targetPoints: info?.data?.targetPoints,
          data: info.data.data
            .sort((a, b) => (a.KpiActivity?.name > b.KpiActivity?.name ? 1 : -1))
            .map((data) => ({ ...data, prevCount: data?.DailyActions?.[0]?.count })),
          pointGoals: info?.data?.pointGoals,
          activeStreak: info?.data?.activeStreak,
          outOfOfficeDays: info?.data?.outOfOfficeDays,
        })
      );
    } else if (info?.response?.status !== 403) {
      enqueueSnackbar(
        JSON.stringify({
          icon: "error",
          title: "Error",
          text: info?.response?.data?.message || "Something went wrong",
        }),
        {
          variant: "custom",
        }
      );
      yield put(homeAction.getKpiEntryFail());
    }
  } catch (error) {
    enqueueSnackbar(
      JSON.stringify({
        icon: "error",
        title: "Error",
        text: error?.response?.data?.message || error.message || "Something went wrong",
      }),
      {
        variant: "custom",
      }
    );
    yield put(homeAction.getKpiEntryFail());
  }
}

export function* changeKpiEntry(action) {
  const {
    updatedActionData: payload,
    handleCompetitionActivityUpdate,
    handleCompetitionUpdateFail,
    actionPayload,
  } = action.payload;

  try {
    if (payload.call) {
      const info = yield updateKpiEntry({
        count: payload.count,
        points: payload.points,
        kpiActionId: payload.kpiActionId,
      });
      if (info?.data?.success) {
        yield put(homeAction.setLastUpdatedTimestamp(info.data?.data?.lastUpdated || new Date()));
        if (handleCompetitionActivityUpdate && actionPayload.length > 0) {
          yield handleCompetitionActivityUpdate(actionPayload);
        }
        yield put(homeAction.updateKpiEntry({ info: info.data.data }));
      } else if (info?.response?.status !== 403) {
        enqueueSnackbar(
          JSON.stringify({
            icon: "error",
            title: "Error",
            text: info?.response?.data?.message || "Something went wrong",
          }),
          {
            variant: "custom",
          }
        );
        yield put(homeAction.updateKpiEntryFail({ kpiActionId: payload.kpiActionId }));
        if (handleCompetitionUpdateFail && actionPayload.length > 0) {
          yield handleCompetitionUpdateFail(actionPayload);
        }
      }
    } else if (payload.limitExceeded) {
      yield put(
        homeAction.updateKpiEntry({
          info: { ...payload, kpiActionId: payload.kpiActionId },
        })
      );
    }
  } catch (error) {
    enqueueSnackbar(
      JSON.stringify({
        icon: "error",
        title: "Error",
        text: error?.response?.data?.message || error.message || "Something went wrong",
      }),
      {
        variant: "custom",
      }
    );
    yield put(homeAction.getKpiEntrySaga());
    if (handleCompetitionUpdateFail && actionPayload.length > 0) {
      yield handleCompetitionUpdateFail(actionPayload);
    }
  }
}

export function* getMyTeamData(action) {
  try {
    const info = yield fetchTeamData(action.payload);

    if (info?.data?.success) {
      yield put(
        homeAction.getMyTeamData({
          data: info.data.data,
        })
      );
    } else if (info?.response?.status !== 403) {
      enqueueSnackbar(
        JSON.stringify({
          icon: "error",
          title: "Error",
          text: info?.response?.data?.message || "Something went wrong",
        }),
        {
          variant: "custom",
        }
      );
      yield put(homeAction.getMyTeamDataFail());
    }
  } catch (error) {
    enqueueSnackbar(
      JSON.stringify({
        icon: "error",
        title: "Error",
        text: error?.response?.data?.message || error.message || "Something went wrong",
      }),
      {
        variant: "custom",
      }
    );
    yield put(homeAction.getMyTeamDataFail());
  }
}

export function* updateSortByOrderOfKpi(action) {
  try {
    const info = yield updateSortByOrderOfKpiApi(action.payload);

    if (info?.data?.success) {
      yield put(
        homeAction.handleSortByOrderOfKpiSuccess({
          data: info.data.data,
        })
      );
    } else if (info?.response?.status !== 403) {
      enqueueSnackbar(
        JSON.stringify({
          icon: "error",
          title: "Error",
          text: info?.response?.data?.message || "Something went wrong",
        }),
        {
          variant: "custom",
        }
      );
      yield put(homeAction.handleSortByOrderOfKpiFail());
    }
  } catch (error) {
    enqueueSnackbar(
      JSON.stringify({
        icon: "error",
        title: "Error",
        text: error?.response?.data?.message || error.message || "Something went wrong",
      }),
      {
        variant: "custom",
      }
    );
    yield put(homeAction.handleSortByOrderOfKpiFail());
  }
}

export function* getWeeklyTotalsSaga(action) {
  try {
    if (!action?.payload?.filter?.teamList?.length && !action?.payload?.filter?.userList?.length) {
      yield put(
        homeAction.getWeeklyTotalsSuccess({
          data: [],
        })
      );
    } else {
      const info = yield fetchWeeklyTotals(action.payload);

      if (info?.data?.success) {
        const { data } = info.data;

        yield put(
          homeAction.getWeeklyTotalsSuccess({
            data,
          })
        );
      } else {
        yield put(
          homeAction.getWeeklyTotalsFailed({
            errorMessage:
              info?.response?.status === 403
                ? ""
                : info?.response?.data?.message || "Something went wrong",
          })
        );
      }
    }
  } catch (error) {
    enqueueSnackbar(
      JSON.stringify({
        icon: "error",
        title: "Error",
        text: error.message || "Something went wrong",
      }),
      {
        variant: "custom",
      }
    );
    yield put(homeAction.getWeeklyTotalsFailed());
  }
}

export function* updateCelebrationDate(action) {
  let errorMsg = "";
  try {
    const response = yield updateUserCelebrationDate(action.payload);
    if (!response.data?.success) {
      errorMsg = response?.data?.message || "Something went wrong";
    }
  } catch (error) {
    errorMsg = error?.response?.data?.message || error.message || "Something went wrong";
  } finally {
    if (errorMsg) {
      enqueueSnackbar(
        JSON.stringify({
          icon: "error",
          title: "Error",
          text: errorMsg,
        }),
        {
          variant: "custom",
        }
      );
    }
  }
}

export function* getCelebrationDetails(action) {
  let errorMsg = "";
  try {
    const response = yield getUserCelebrationDetails(action.payload);
    if (response.data?.success) {
      yield put(homeAction.getCelebrationDetailsRetrieved(response.data.data));
    } else {
      errorMsg = response?.data?.message || "Something went wrong";
    }
  } catch (error) {
    errorMsg = error?.response?.data?.message || error.message || "Something went wrong";
  } finally {
    if (errorMsg) {
      enqueueSnackbar(
        JSON.stringify({
          icon: "error",
          title: "Error",
          text: errorMsg,
        }),
        {
          variant: "custom",
        }
      );
    }
  }
}

export function* updateSoundEnabled(action) {
  let errorMsg = "";
  try {
    const response = yield updateSoundEnabledConfig(action.payload);
    if (!response.data?.success) {
      errorMsg = response?.data?.message || "Something went wrong";
    }
  } catch (error) {
    errorMsg = error?.response?.data?.message || error.message || "Something went wrong";
  } finally {
    if (errorMsg) {
      enqueueSnackbar(
        JSON.stringify({
          icon: "error",
          title: "Error",
          text: errorMsg,
        }),
        {
          variant: "custom",
        }
      );
    }
  }
}

export function* clearNotifications(action) {
  let errorMsg = "";
  try {
    const response = yield clearAllNotifications(action.payload);
    if (!response.data?.success) {
      errorMsg = response?.data?.message || "Something went wrong";
    }
  } catch (error) {
    errorMsg = error?.response?.data?.message || error.message || "Something went wrong";
  } finally {
    if (errorMsg) {
      enqueueSnackbar(
        JSON.stringify({
          icon: "error",
          title: "Error",
          text: errorMsg,
        }),
        {
          variant: "custom",
        }
      );
    }
  }
}

export function* setSeenUserNotification(action) {
  let errorMsg = "";
  try {
    const response = yield setSeenNotification(action.payload);
    if (!response.data?.success) {
      errorMsg = response?.data?.message || "Something went wrong";
    }
  } catch (error) {
    errorMsg = error?.response?.data?.message || error.message || "Something went wrong";
  } finally {
    if (errorMsg) {
      enqueueSnackbar(
        JSON.stringify({
          icon: "error",
          title: "Error",
          text: errorMsg,
        }),
        {
          variant: "custom",
        }
      );
    }
  }
}

export function* clearNotificationsForWinWireMessage(action) {
  let errorMsg = "";
  try {
    const response = yield clearAllNotificationsForWinWireMessage(action.payload);
    if (!response.data?.success) {
      errorMsg = response?.data?.message || "Something went wrong";
    }
  } catch (error) {
    errorMsg = error?.response?.data?.message || error.message || "Something went wrong";
  } finally {
    if (errorMsg) {
      enqueueSnackbar(
        JSON.stringify({
          icon: "error",
          title: "Error",
          text: errorMsg,
        }),
        {
          variant: "custom",
        }
      );
    }
  }
}

export function* fetchNotifications(action) {
  let errorMsg = "";
  try {
    const content = yield fetchUserNotifications(action.payload);

    if (content.data?.success) {
      yield put(homeAction.setNotifications(content.data.data));
    } else if (content.response?.status !== 403) {
      errorMsg = content.response?.data?.message || "Something went wrong";
    }
  } catch (error) {
    errorMsg = error?.response?.data?.message || error.message || "Something went wrong";
  } finally {
    if (errorMsg) {
      enqueueSnackbar(
        JSON.stringify({
          icon: "error",
          title: "Error",
          text: errorMsg,
        }),
        {
          variant: "custom",
        }
      );
    }
    yield put(homeAction.fetchNotificationsFinished());
  }
}

export function* watchHomeAsync() {
  yield takeEvery(homeAction.getDailyPointsInfoSaga, getDailyPointsInfo);
  yield takeEvery(homeAction.getUserAchievements, getUserAchievements);
  yield takeEvery(homeAction.getKpiEntrySaga, getKpiEntry);
  yield takeEvery(homeAction.updateKpiEntrySaga, changeKpiEntry);
  yield takeEvery(homeAction.getMyTeamDataSaga, getMyTeamData);
  yield takeEvery(homeAction.updateSortByOrderOfKpiSaga, updateSortByOrderOfKpi);
  yield takeEvery(homeAction.getWeeklyTotalsRequest, getWeeklyTotalsSaga);
  yield takeEvery(homeAction.updateCelebrationDate, updateCelebrationDate);
  yield takeEvery(homeAction.getCelebrationDetailsAction, getCelebrationDetails);
  yield takeEvery(homeAction.updateSoundEnabled, updateSoundEnabled);
  yield takeEvery(homeAction.fetchNotificationsSaga, fetchNotifications);
  yield takeEvery(homeAction.clearNotificationsSaga, clearNotifications);
  yield takeEvery(homeAction.setSeenNotificationSaga, setSeenUserNotification);
  yield takeEvery(
    homeAction.clearNotificationsForWinWireMessage,
    clearNotificationsForWinWireMessage
  );
}
